module.exports = __webpack_public_path__ + "media/moon.7a129265.svg";